var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssignment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8050_3702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 5.00008H24.7C24 3.06675 22.1667 1.66675 20 1.66675C17.8333 1.66675 16 3.06675 15.3 5.00008H8.33333C6.5 5.00008 5 6.50008 5 8.33341V31.6667C5 33.5001 6.5 35.0001 8.33333 35.0001H31.6667C33.5 35.0001 35 33.5001 35 31.6667V8.33341C35 6.50008 33.5 5.00008 31.6667 5.00008ZM20 5.00008C20.9167 5.00008 21.6667 5.75008 21.6667 6.66675C21.6667 7.58341 20.9167 8.33341 20 8.33341C19.0833 8.33341 18.3333 7.58341 18.3333 6.66675C18.3333 5.75008 19.0833 5.00008 20 5.00008ZM23.3333 28.3334H11.6667V25.0001H23.3333V28.3334ZM28.3333 21.6667H11.6667V18.3334H28.3333V21.6667ZM28.3333 15.0001H11.6667V11.6667H28.3333V15.0001Z",
    fill: "#0000FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8050_3702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignment);
export default __webpack_public_path__ + "static/media/assignment.0f2bec2a7dc5e0aea18fdde13565e2c8.svg";
export { ForwardRef as ReactComponent };